module.exports = __webpack_public_path__ + "img/icon2.42ca2e27.png";